import React from 'react';
import './PortfolioSummary.css';

interface MetricData {
  label: string;
  value: string;
  change: string;
  changeType: 'positive' | 'negative' | 'neutral';
}

interface PortfolioSummaryProps {
  metrics: MetricData[];
}

const PortfolioSummary: React.FC<PortfolioSummaryProps> = ({ metrics }) => {
  return (
    <section className="portfolio-summary">
      {metrics.map((metric, index) => (
        <div key={index} className="summary-metric">
          <div className="metric-label">{metric.label}</div>
          <div className={`metric-value ${metric.changeType === 'positive' ? 'positive' : metric.changeType === 'negative' ? 'negative' : ''}`}>
            {metric.value}
          </div>
          <div className={`metric-change ${metric.changeType}`}>
            {metric.change}
          </div>
        </div>
      ))}
    </section>
  );
};

export default PortfolioSummary;
